import { Navigate, useLocation } from 'react-router-dom';

/** Old /my-day links (emails, bookmarks, stored notifications) land on Your Desk with their query intact. */
export default function LegacyDeskRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={`/desk${search}${hash}`} replace />;
}
